import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function fileAvatarFileShow(
  account_id: string,
  avatar_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/avatar/file/${avatar_id}/show${queryString}`,
  );
}

export async function fileAvatarCreate(
  account_id: string,
  payload: { owner_id: string; type: string; file: string },
) {
  return await clientAxios.post(`account/${account_id}/avatar/create`, payload);
}

export async function fileAvatarUpdate(
  account_id: string,
  avatar_id: string,
  payload: { file: string },
) {
  return await clientAxios.put(
    `account/${account_id}/avatar/${avatar_id}/update`,
    payload,
  );
}

export async function fileAvatarDelete(account_id: string, avatar_id: string) {
  return await clientAxios.del(
    `account/${account_id}/avatar/${avatar_id}/delete`,
  );
}
